import React from "react"
import { Body } from "components/Shell/Shell"
import { parseUrlQuery } from "utilities"
import { Spinner } from "components/Loaders/Loaders"
import CrossIcon from "@tecuity/sos-icons/react/cross-heavy"
import {
  GET_ACCESS_ID_CC_PAYMENT_STATUS,
  GET_ACCESS_ID_LOC_PAYMENT_STATUS,
  GET_PAYPAL_PAYMENT_STATUS
} from "requests"

export default class PaymentCallback extends React.Component {
  state = {
    error: false,
    errorMessage: null
  }
  componentDidMount = () => {
    const { method } = this.props.match.params
    if (method) {
      this.processByMethod(method)
    }
  }
  toggleError = errorMessage => {
    this.setState({ error: true, errorMessage: errorMessage || null })
  }
  processByMethod = method => {
    switch (method.toLowerCase()) {
      case "accessidcc":
        this.getAccessIDCCPaymentStatus()
        break
      case "accessidloc":
        this.getAccessIDLOCPaymentStatus()
        break
      case "paypal":
        this.getPaypalPaymentStatus()
        break
      default:
    }
  }
  getAccessIDCCPaymentStatus = () => {
    const { token } = parseUrlQuery(this.props.location.search)
    if(token){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_ACCESS_ID_CC_PAYMENT_STATUS(token, ({SECURETOKENID}) => {
      this.redirectToReceipt(SECURETOKENID)
    }, err => {
      console.error(err);
      this.toggleError(err.message)
    })
  }
  getAccessIDLOCPaymentStatus = () => {
    const { token } = parseUrlQuery(this.props.location.search)
    if(token){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_ACCESS_ID_LOC_PAYMENT_STATUS(token, ({SECURETOKENID}) => {
      this.redirectToReceipt(SECURETOKENID)
    }, err => {
      console.error(err);
      this.toggleError(err.message)
    })
  }
  getPaypalPaymentStatus = () => {
    const { SECURETOKENID } = parseUrlQuery(this.props.location.search)
    if(SECURETOKENID){
      this.props.history.replace(this.props.location.pathname)
    }
    GET_PAYPAL_PAYMENT_STATUS(SECURETOKENID, () => {
      this.redirectToReceipt(SECURETOKENID)
    }, err => {
      console.error(err)
      this.toggleError(err.message)
    })
  }
  handlePaypalPayment = () => {
    const { SECURETOKENID } = parseUrlQuery(this.props.location.search)
    this.redirectToReceipt(SECURETOKENID)
  }
  redirectToReceipt = refNum => {
    this.props.history.replace(`/receipt?ref=${refNum}`)
  }
  render() {
    return (
      <Body className="login-redirector payment-callback">
        {
          this.state.error ?
          <PaymentError>{this.state.errorMessage}</PaymentError>
          :
          <div className="flex-column animated fadeIn delay">
            <Spinner className="page-loader" size='medium' themeColor='secondary' />
            <h1 className='message'>Processing your payment</h1>
          </div>
        }
      </Body>
    )
  }
}

export const PaymentError = ({children, errorCode, errorMessage, errorTitle}) => (
  <div className="flex-column">
    <CrossIcon className="text-danger"/>
    <h1 className='message text-danger'>{errorTitle || 'Something went wrong'}</h1>
    {
      typeof children === 'object' ?
      <div className="text-danger pre-wrap">
        {
          children || "An error has occurred while trying to process your payment."
        }
      </div>
      :
      <p className='text-danger pre-wrap'>
        {
          children || "An error has occurred while trying to process your payment."
        }
      </p>
    }
    {
      (errorCode || errorMessage) &&
      <p className='text-danger'>
        <strong>Code {errorCode}</strong> : {errorMessage}
      </p>
    }
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Checkout/PaymentCallback.js